
export default function CallToAction() {
  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='1'/%3E%3Ccircle cx='53' cy='7' r='1'/%3E%3Ccircle cx='7' cy='53' r='1'/%3E%3Ccircle cx='53' cy='53' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Ready to Transform Your Vision?
          </h2>
          <p className="text-xl md:text-2xl text-blue-100 mb-8 leading-relaxed">
            Get a free consultation and quote for your vehicle wrap, window tinting, 
            or commercial signage project. Let's bring your ideas to life with exceptional quality and service.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
            <button className="bg-white text-blue-600 px-10 py-4 text-lg font-bold rounded-lg hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap shadow-lg">
              Get Your Free Quote
            </button>
            <button className="border-2 border-white text-white px-10 py-4 text-lg font-bold rounded-lg hover:bg-white hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
              Call 240.727.2803
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Call Us Today</h3>
              <p className="text-blue-100 text-sm">Speak with our experts</p>
              <p className="text-white font-bold mt-2">240.727.2803</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Email Quote</h3>
              <p className="text-blue-100 text-sm">Get detailed pricing</p>
              <p className="text-white font-bold mt-2">info@thebensondesigns.com</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Visit Our Shop</h3>
              <p className="text-blue-100 text-sm">See our work in person</p>
              <p className="text-white font-bold mt-2">Schedule Tour</p>
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-blue-100 text-lg">
              ⚡ Same-day quotes available • 🛡️ Fully licensed & insured • ✅ 100% satisfaction guaranteed
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
